import { postData } from './common/api';
import {
  fetchCart,
  getCartLevelDiscountAllocations,
  getCurrencyFromShopifyCart,
  getMRCartFromShopifyCart,
  isPresentInCart,
} from './common/cart';
import { getOfferEndpoint } from './common/constants';
import { getCustomerId } from './common/offerData';
import { getDevice, isInaEss } from './common/pageData';
import {
  getFloating,
  getOfferID,
  getOrderID,
  isDisabled,
  setFloatingInDisplay,
  setOfferID,
  setOrderID,
  setMrActiveOffer,
  setFloating,
} from './common/settings';
import { generateString } from './common/strings';
import { renderInDiv } from './features/popupModule';

export async function displayFloatingOffer() {
  if (isDisabled() === 'true') {
    return;
  }

  if (getFloating() === 'true') {
    const cart = await fetchCart();
    if (cart.items.length === 0) {
      // floating  close as no item present in cart for display
      return;
    }

    const primary = getPrimaryForFloating();
    const offerRequest = {};
    offerRequest['primary'] = primary;
    offerRequest['cart'] = getMRCartFromShopifyCart(cart);
    offerRequest.cart_level_discount_applications = getCartLevelDiscountAllocations(
      cart,
    );
    offerRequest['currency'] = getCurrencyFromShopifyCart(cart);
    offerRequest['source'] = 'floating';
    offerRequest['device'] = getDevice();
    offerRequest['mr_order_id'] = getOrderID();
    offerRequest['mr_offer_id'] = getOfferID();
    offerRequest.customerId = getCustomerId();
    offerRequest.popupTriggerType = 'floating';

    const response = await postData(getOfferEndpoint(), offerRequest);
    if (response) {
      setMrActiveOffer(response.offer);
      setFloatingInDisplay(true);
      const offered = response.offer.offered;
      setOrderID(response.order_id);
      setOfferID(response.offer.mr_offer_id);
      renderInDiv({
        products: offered,
        open: false,
        expand: false,
        primary: response.offer.primary,
        theme: response.offer.theme,
        isTimerDisabled: response.offer.isTimerDisabled,
        isDiscountDisabled: response.offer.isDiscountDisabled,
        loadingOffer: true,
        timer: response.offer.timer,
        trigger: 'floating',
        eventID: generateString(5),
        cart: offerRequest['cart'],
        event: {},
        triggerType: response.offer.triggerType,
        floatingDisabled: response.offer.floatingDisabled,
        offerType: response.offer.type,
        currencyFormat: response.offer.currencyFormat,
        discountType: response.offer.discountType,
        discountValue: response.offer.discountValue,
        discountQuantity: response.offer.discountQuantity,
        isDiscountQuantityRestricted:
          response.offer.isDiscountQuantityRestricted,
        isNumberOfOfferedProductsRestricted:
          response.offer.isNumberOfOfferedProductsRestricted,
        isDiscountCodeApplicable: response.offer.isDiscountCodeApplicable,
        isDisableOfferOnClose: response.offer.isDisableOfferOnClose,
        checkoutOnSkip: false,
        isBrandingEnabled: response.offer.isBrandingEnabled,
        priceRoundType: response.offer.priceRoundType,
        discountRoundType: response.offer.discountRoundType,
        offerLevelDiscountQuantity: response.offer.offerLevelDiscountQuantity,
      });
    } else {
      // floating close as no offer is eligible
      if (isInaEss()) {
        setFloating(false);
      }
    }
  }
}

export async function expandFloatingOffer(
  products,
  theme,
  timer,
  trigger,
  eventID,
  isTimerDisabled,
  isDiscountDisabled,
  triggerType,
  floatingDisabled,
  offerType,
  currencyFormat,
  discountType,
  discountValue,
  discountQuantity,
  isDiscountQuantityRestricted,
  isNumberOfOfferedProductsRestricted,
  isDiscountCodeApplicable,
  isDisableOfferOnClose,
  isBrandingEnabled,
  priceRoundType,
  discountRoundType,
  offerLevelDiscountQuantity,
) {
  const cart = await fetchCart();

  const primary = getPrimaryForFloating();
  renderInDiv({
    products: products,
    open: true,
    expand: true,
    primary: primary,
    loadingOffer: true,
    theme,
    isTimerDisabled,
    isDiscountDisabled,
    timer,
    trigger: trigger,
    eventID,
    cart: getMRCartFromShopifyCart(cart),
    event: {},
    triggerType,
    floatingDisabled: floatingDisabled,
    offerType,
    currencyFormat,
    discountType,
    discountValue,
    discountQuantity,
    isDiscountQuantityRestricted,
    isNumberOfOfferedProductsRestricted,
    isDiscountCodeApplicable,
    isDisableOfferOnClose,
    checkoutOnSkip: false,
    isBrandingEnabled,
    priceRoundType,
    discountRoundType,
    offerLevelDiscountQuantity,
  });

  if (cart.items.length === 0) {
    // floating close as no item present in cart
    renderInDiv({
      products: [],
      open: false,
      expand: true,
      primary: primary,
      theme: {},
      isTimerDisabled: false,
      isDiscountDisabled: false,
      loadingOffer: false,
      timer: 0,
      trigger: trigger,
      eventID,
      cart: getMRCartFromShopifyCart(cart),
      event: {},
      triggerType,
      floatingDisabled: floatingDisabled,
      offerType,
      currencyFormat,
      discountType,
      discountValue,
      discountQuantity,
      isDiscountQuantityRestricted,
      isNumberOfOfferedProductsRestricted,
      isDiscountCodeApplicable,
      isDisableOfferOnClose,
      checkoutOnSkip: false,
      isBrandingEnabled,
      priceRoundType,
      discountRoundType,
      offerLevelDiscountQuantity,
    });
    return;
  }

  if (isPresentInCart(primary.sp_product_id, primary.sp_variant_id, cart)) {
    //if offered products are there, then just check if primary is present in cart
    if (products.length > 0) {
      renderInDiv({
        products: products,
        open: true,
        expand: true,
        primary: primary,
        loadingOffer: false,
        theme,
        isTimerDisabled,
        isDiscountDisabled,
        timer,
        trigger: trigger,
        eventID,
        cart: getMRCartFromShopifyCart(cart),
        event: {},
        triggerType,
        floatingDisabled: floatingDisabled,
        offerType,
        currencyFormat,
        discountType,
        discountValue,
        discountQuantity,
        isDiscountQuantityRestricted,
        isNumberOfOfferedProductsRestricted,
        isDiscountCodeApplicable,
        checkoutOnSkip: false,
        isBrandingEnabled,
        priceRoundType,
        discountRoundType,
        offerLevelDiscountQuantity,
      });
      return;
    }
    // renderInDiv({
    //   products: [],
    //   open: false,
    //   expand: false,
    //   primary: primary,
    //   theme: {},
    //   loadingOffer: false,
    //   timer: 0,
    //   trigger: trigger,
    //   eventID,
    // });
  }

  const offerRequest = {};
  offerRequest['primary'] = primary;
  // if (trigger === "bn") {
  //   offerRequest["cart"] = increaseQuantityAndGetMrCart(
  //     cart,
  //     productID,
  //     variantID
  //   );
  // } else {
  offerRequest['cart'] = getMRCartFromShopifyCart(cart);
  offerRequest.cart_level_discount_applications = getCartLevelDiscountAllocations(
    cart,
  );
  // }

  offerRequest['currency'] = getCurrencyFromShopifyCart(cart);
  offerRequest['source'] = 'floating';
  offerRequest['device'] = getDevice();
  offerRequest['mr_order_id'] = getOrderID();
  offerRequest['mr_offer_id'] = getOfferID();
  offerRequest.customerId = getCustomerId();
  offerRequest.popupTriggerType = 'product';

  const response = await postData(getOfferEndpoint(), offerRequest);

  if (response && response.is_eligible === true) {
    const offered = response.offer.offered;
    setOfferID(response.offer.mr_offer_id);
    setOrderID(response.order_id);
    renderInDiv({
      products: offered,
      open: true,
      expand: true,
      primary: response.offer.primary,
      loadingOffer: false,
      theme: response.offer.theme,
      isTimerDisabled: response.offer.isTimerDisabled,
      isDiscountDisabled: response.offer.isDiscountDisabled,
      timer: response.offer.timer,
      trigger: trigger,
      eventID,
      cart: offerRequest['cart'],
      event: {},
      triggerType: response.offer.triggerType,
      floatingDisabled: response.offer.floatingDisabled,
      offerType: response.offer.type,
      currencyFormat: response.offer.currencyFormat,
      discountType: response.offer.discountType,
      discountValue: response.offer.discountValue,
      discountQuantity: response.offer.discountQuantity,
      isDiscountQuantityRestricted: response.offer.isDiscountQuantityRestricted,
      isNumberOfOfferedProductsRestricted:
        response.offer.isNumberOfOfferedProductsRestricted,
      isDiscountCodeApplicable: response.offer.isDiscountCodeApplicable,
      isDisableOfferOnClose: response.offer.isDisableOfferOnClose,
      checkoutOnSkip: false,
      isBrandingEnabled: response.offer.isBrandingEnabled,
      priceRoundType: response.offer.priceRoundType,
      discountRoundType: response.offer.discountRoundType,
      offerLevelDiscountQuantity: response.offer.offerLevelDiscountQuantity,
    });
  } else {
    if (isInaEss()) {
      setFloating(false);
    }
    // floating close as no offer is eligible
  }
}

function getPrimaryForFloating() {
  const sp_product_id = getPrimaryProductIDForFloating();
  const sp_variant_id = getPrimaryVariantIDForFloating();
  const primaryProductDetails = getPrimaryProductDetailsForFloating();
  return {
    sp_product_id: sp_product_id,
    sp_variant_id: parseInt(sp_variant_id),
    ...primaryProductDetails,
  };
}

function getPrimaryProductIDForFloating() {
  return parseInt(sessionStorage.getItem('mr_floating_primary_id1'));
}

function getPrimaryVariantIDForFloating() {
  return parseInt(sessionStorage.getItem('mr_floating_primary_id2'));
}

function getPrimaryProductDetailsForFloating() {
  return JSON.parse(sessionStorage.getItem('mr_floating_primary_details'));
}

export function setPrimaryForFloating(primary) {
  const { sp_product_id, sp_variant_id, ...rest } = primary;
  sessionStorage.setItem('mr_floating_primary_id1', sp_product_id);
  sessionStorage.setItem('mr_floating_primary_id2', sp_variant_id);
  sessionStorage.setItem('mr_floating_primary_details', JSON.stringify(rest));
}
